<template>
  <div>
    <b-card>
      <b-row class="">
        <b-col class="col-md-6">
          <h2 class="text-blue font-weight-bold mt-1">
            {{ $t("to_do") }}
          </h2>
        </b-col>
        <b-col class="col-md-6 text-right mt-1">
          <b-form-radio-group
              v-model="filterStatus"
              :options="filterOptions"
              buttons
              button-variant="outline-primary"
              size="sm"
              name="radio-btn-outline"
              @change="updateTableData"
          ></b-form-radio-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <Table
          :fields="tableFields"
          :items="todos"
          :url="url"
          :body="{ status: filterStatus }"
          :updateData="updateTrigger"
          class="position-relative mt-2"
          hover
          responsive
          show-empty
          striped
      >
        <template #head()="scope">
          <div class="text-nowrap">{{ $t(scope.label) }}</div>
        </template>
        <template #cell(created_at)="data">
          <p style="width:90px !important;">{{ data.value.substring(10, 0) }}</p>
        </template>

        <template #cell(time)="data">
          {{ data.item.created_at.substring(11, 16) }}
        </template>
        <template #cell(company_name)="data">
          <span v-if="data.item.to_do_company && data.item.to_do_company.name != null">{{ data.item.to_do_company.name }}</span>
          <span v-else-if="data.item.to_do_company">{{ data.item.to_do_company.main_contact_person.name }} {{ data.item.to_do_company.main_contact_person.last_name }}</span>
          <span v-else-if="data.item.action === 'new_investment_profile'">{{ decodeData(data.item.data).company_name }}</span>
          <span v-else></span>
        </template>
        <template #cell(description)="data">
          <p style="width:180px" v-if="data.item.description && data.item.action === 'referral_program_check'">
            <span class="text-info">{{ $t(data.item.description) }}</span>
          </p>
          <p style="width:180px" v-else-if="data.item.description">
            {{ $t(data.item.description) }}
          </p>
          <span v-else>-</span>
        </template>
        <template #cell(company_id)="data">
          <p class="badge badge-light-primary" style="width:55px;" v-if="data.item.invoice_id == null">
            <span v-if="data.item.company_id">
              C-{{ data.item.company_id }}
            </span>
            <span v-else-if="data.item.action === 'new_investment_profile'" @click="navigateInvestmentProfile(data.item)">
              IPR-{{ decodeData(data.item.data).investment_profile_id }}
            </span>
          </p>
          <b-link
              v-else
              :to="adminType(['super_admin','admin_type_a']) ? '/invoice/' + data.item.invoice_id : null"
              class="badge badge-light-primary"
              :tabindex="adminType(['super_admin','admin_type_a']) ? 0 : -1"
              :style="adminType(['super_admin','admin_type_a']) ? 'width:55px;' : 'width:55px; pointer-events: none; '">
            I-{{ data.item.invoice_id }}
          </b-link>
        </template>
        <template #cell(change_status)="data">
          <p class="pb-0 mb-0" style="width:180px">
            <b-button :title="$t('set_completed')" @click="setCompleted(data.item)" :disabled="buttons_disabled" class="mr-1" size="sm" v-b-tooltip.hover v-if="data.item.action != 'referral_program_check' && data.item.status == 0 && adminType(['super_admin','admin_type_a'])" variant="outline-success">
              <feather-icon icon="CheckCircleIcon"/>
            </b-button>
            <b-button :title="$t('set_closed')" @click="setClosed(data.item)" :disabled="buttons_disabled" class="mr-1" size="sm" v-b-tooltip.hover v-if="data.item.action != 'referral_program_check'  && data.item.action != 'new_investment_profile' && data.item.status == 0 && adminType(['super_admin'])" variant="outline-danger">
              <feather-icon icon="XIcon"/>
            </b-button>
            <b-button  :title="$t('set_pending')" @click="setPending(data.item)" :disabled="buttons_disabled" class="mr-1" size="sm" v-b-tooltip.hover v-if="data.item.action != 'referral_program_check' && data.item.status == 2 && adminType(['super_admin','admin_type_a'])" variant="outline-warning">
              <feather-icon icon="RefreshCwIcon"/>
            </b-button>
            <span v-else></span>
          </p>
        </template>
        <template #cell(actions)="data">
          <template v-if="data.item.company_id">
            <template v-if="data.item.invoice_id != null">
              <b-button :to="'/invoice/' + data.item.invoice_id" class="mr-1" size="sm" variant="outline-dark">
                <feather-icon icon="CheckCircleIcon"/>
              </b-button>
            </template>
            <template v-else>
              <b-button @click="redirect(data.item)" class="mr-1" size="sm" v-if="data.item.status == 0 && data.item.action != 'warning'" variant="outline-dark">
                <feather-icon icon="CheckCircleIcon"/>
              </b-button>
              <p class="pb-0 mb-0" style="width:120px" v-if="data.item.status == 0 && data.item.action == 'warning'">
                <b-button :title="$t('settle_invoice')" @click="settleInvoice(data.item)" class="mr-1" size="sm" v-b-tooltip.hover variant="outline-warning">
                  <feather-icon icon="CheckCircleIcon"/>
                </b-button>

                <b-button :title="$t('trigger_warning')" @click="triggerWarning(data.item)" class="mr-1" id="trigger_warning_btn" size="sm" v-b-tooltip.hover variant="outline-success">
                  <feather-icon icon="InfoIcon"/>
                </b-button>
              </p>
            </template>
          </template>
          <template v-else-if="data.item.action === 'referral_program_check'">
            <b-button @click="navigateReferralProgram" class="mr-1" size="sm" variant="outline-info">
              <feather-icon icon="CheckCircleIcon"/>
            </b-button>
          </template>
          <template v-else-if="data.item.action === 'new_investment_profile'">
            <b-button @click="navigateInvestmentProfile(data.item)" class="mr-1" size="sm" variant="outline-dark">
              <feather-icon icon="CheckCircleIcon"/>
            </b-button>
          </template>
          <template v-else>
            <b-button @click="navigateToSendEmail" class="mr-1" size="sm" variant="outline-dark">
              <feather-icon icon="CheckCircleIcon"/>
            </b-button>
          </template>

          <span v-else></span>
        </template>
        <template #cell(status)="data">
          <span v-if="data.value == 0">{{ $t("pending") }} </span>
          <span v-if="data.value == 1">{{ $t("completed") }}</span>
          <span v-if="data.value == 2">{{ $t("closed") }}</span>
        </template>
      </Table>
    </b-card>
  </div>
</template>

<script>
import {BButton, BCol, BFormGroup, BFormInput, BLink, BPagination, BRow, BTable, BTh, BTr, BFormRadioGroup} from "bootstrap-vue";
import CustomLoader from "@/components/Common/CustomLoader";
import Table from "@/components/Common/Table2";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    Table,
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BPagination,
    BTr,
    BTh,
    BButton,
    BLink,
    CustomLoader,
    BFormRadioGroup
  },
  directives: {
    Ripple,
  },
  computed: {
    rows() {
      return this.totalItems;
    },
    tableFields() {
      const fields = [
        {
          key: "created_at",
          label: "Date",
        },
        {
          key: "time",
          label: "Time",
        },
        {
          key: "company_id",
          label: "ID",
        },
        {
          key: "company_name",
          label: "Company Name",
        },
        {
          key: "description",
          label: "description",
        },
        {
          key: "status",
          label: "status",
        },
      ];

      if (this.adminType(['super_admin', 'admin_type_a'])) {
        fields.push({
              key: "actions",
              label: "to_do",
            },
            {
              key: "change_status",
              label: "change_status",
            },
        );
      }

      return fields;
    }
  },
  data() {
    return {
      page: 1,
      totalItems: 0,
      url: '/task/todo',
      buttons_disabled: false,
      todos: null,
      filterStatus: 0,
      filterOptions: [
        { text: 'Pending', value: 0 },
        { text: 'All', value: 'all' }
      ],
      updateTrigger: 0,
    };
  },
  methods: {
    updateTableData() {
      this.updateTrigger++;
    },
    navigateToSendEmail() {
      this.$router.push('/send/email');
    },

    navigateReferralProgram() {
      this.$router.push('/referral-program');
    },

    navigateInvestmentProfile(item) {
      let data = JSON.parse(item.data);
      let id = data.investment_profile_id;
      this.$router.push(`/admin-investment-profile/${id}`);
    },

    decodeData(data) {
      try {
        return typeof data === 'string' ? JSON.parse(data) : data;
      } catch (e) {
        return {};
      }
    },

    redirect(item) {
      if (item.action == 'transactions' && item.to_do_company.main_contact_person) {
        this.$router.push(`/investor/${item.to_do_company.main_contact_person.id}#transactions`)
      } else if (['activate_invoice', 'debtor_confirmation', 'settle_reverse_invoice'].includes(item.action)) {
        let invoice = JSON.parse(item.data);
        this.$router.push(`/invoice/${invoice.invoice_id}`);
      } else if (item.action == 'verify_user_answers_from_sumsub' && item.to_do_company.main_contact_person) {
        this.$router.push(`/investor/${item.to_do_company.main_contact_person.id}`);
      } else if (['check_debtor_score', 'client_funds_50_day_warning', 'client_funds_60_day_escalation'].includes(item.action)) {
        this.$router.push(`/company/${item.company_id}`);
      } else if (item.action == "currency_exchange" || item.action == "annual_fee_exchange" ) {
        this.$router.push(`/transaction-currency`);
      }
    },
    setClosed(item) {
      this.buttons_disabled = true
      this.$http.post(`/task/todo/${item.id}/closed`).then((res) => {
        if (res) {
          this.showSuccessMessage();
        }
      });
    },
    setPending(item) {
      this.buttons_disabled = true
      this.$http.post(`/task/todo/${item.id}/pending`).then((res) => {
        if (res) {
          this.showSuccessMessage();
        }
      });
    },
    setCompleted(item) {
      this.buttons_disabled = true
      this.$http.post(`/task/todo/${item.id}/finished`).then((res) => {
        if (res) {
          this.showSuccessMessage();
        }
      });
    },
    triggerWarning(item) {
      document.getElementById('trigger_warning_btn').disabled = true
      let invoice = JSON.parse(item.data);
      this.$http.post(`/invoice/admin/trigger-warning/${invoice.invoice_id}/${item.id}`).then((res) => {
        if (res) {
          this.showSuccessMessage();
        }
      });
    },
    settleInvoice(item) {
      let invoice = JSON.parse(item.data);
      this.$http.post(`/invoice/admin/changeStatus/${invoice.invoice_id}`, { status: 11 }).then((res) => {
        if (res) {
          this.setCompleted(item);
        }
      });
    },
    showSuccessMessage() {
      let text = this.$t("success");
      this.$swal({
        position: "center",
        icon: "success",
        title: text,
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
      setTimeout(() => {
        window.location.reload();
      }, 100);

    },
  },
};
</script>

<style scoped>
</style>
